import { PUSH_NOTIFICATION_MESSAGES } from "~/constants/messages/pushNotificationMessages";
import type { ProcessStatus } from "~/functions/api/kintoneSystem";
import type { NotificationData } from "~/utils/useNativePushNotification";
export type NotifiedOverallStatus = "succeeded" | "failed";

export const shouldNotifyOverallStatus = (
  lastNotified: NotifiedOverallStatus | null | undefined,
  nextStatus: ProcessStatus,
): boolean => {
  if (nextStatus !== "succeeded" && nextStatus !== "failed") return false;
  return lastNotified == null;
};

export const buildAppGenerationOverallNotification = (params: {
  organizationId: string;
  projectId: string;
  systemId: string;
  spaceName?: string | null;
  status: NotifiedOverallStatus;
}): NotificationData => {
  const spaceName = params.spaceName ?? "スペース";

  return {
    title:
      params.status === "succeeded"
        ? PUSH_NOTIFICATION_MESSAGES.APP_DEVELOPMENT.SUCCESS_TITLE
        : PUSH_NOTIFICATION_MESSAGES.APP_DEVELOPMENT.FAILURE_TITLE,
    message:
      params.status === "succeeded"
        ? PUSH_NOTIFICATION_MESSAGES.APP_DEVELOPMENT.SUCCESS(spaceName)
        : PUSH_NOTIFICATION_MESSAGES.APP_DEVELOPMENT.FAILURE(spaceName),
    organization_id: params.organizationId,
    project_id: params.projectId,
    url: `/${params.organizationId}/project/${params.projectId}/app-generation/${params.systemId}`,
  };
};
